import { ecorEnv } from '@/../environments/environment';
import { Component, OnInit, OnDestroy, inject, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService, Languages } from '@/common/services/language.service';
import { HelpDialogData } from '@/landing/dialogs/help-dialog/help-dialog-data';
import { HelpDialogService } from '@/landing/services/help-dialog.service';

@Component({
    selector: 'app-ecorr-sc24-footer',
    templateUrl: './ecorr-sc24-footer.component.html',
    standalone: true,
    imports: [CommonModule, TranslateModule]
})
export class EcorrSC24FooterComponent implements OnInit, OnDestroy {
    // Services using inject()
    private languageService = inject(LanguageService);
    private helpDialogService = inject(HelpDialogService);

    // Signals for reactive state
    selectedLanguage = signal<string>('en');
    language = signal<Languages | null>(null);
    hideVersion = signal(false);

    // Other properties
    languageSub$: Subscription;
    ombNumber = '0607-0368';
    expiryDate = '12/31/2028';

    ngOnInit() {
        this.languageSub$ = this.languageService.language$.subscribe({
            next: (res) => {
                this.language.set(res);
                this.selectedLanguage.set(res.languageCode);
            },
            error: (err) => {
                console.log(err);
            }
        })
    }

    onOMBOpen() {
        let options: HelpDialogData = {
            title: this.languageService.getTranslation('sc24Dialogs.ombDialog.title'),
            content: this.languageService.getTranslation('sc24Dialogs.ombDialog.content'),
            closeButtonLabel: this.languageService.getTranslation('sc24Dialogs.closeLabel'),
            dialogClass: 'sc-dialog'
        };
        this.helpDialogService.open(options);
    }

    onSecurityOpen() {
        let options: HelpDialogData = {
            title: this.languageService.getTranslation('sc24Dialogs.securityDialog.title'),
            content: this.languageService.getTranslation('sc24Dialogs.securityDialog.contentHtml'),
            closeButtonLabel: this.languageService.getTranslation('sc24Dialogs.closeLabel'),
            dialogClass: 'sc-dialog'
        };
        this.helpDialogService.open(options);
    }

    onContactOpen() {
        let options: HelpDialogData = {
            title: this.languageService.getTranslation('sc24Dialogs.contactDialog.title'),
            content: this.languageService.getTranslation('sc24Dialogs.contactDialog.contentHtml'),
            closeButtonLabel: this.languageService.getTranslation('sc24Dialogs.closeLabel'),
            dialogClass: 'sc-dialog'
        };
        this.helpDialogService.open(options);
    }

    ngOnDestroy() {
        if (this.languageSub$) {
            this.languageSub$.unsubscribe();
        }
    }
}
